import type { ReactNode } from 'react';
import type { CardProps, ModalProps } from '..';

export interface ModalWithCardData {}

export interface ModalWithCardProps extends ModalWithCardData {
  modalProps: ModalProps;
  containerProps?: CardProps;
  children: ReactNode;
}
